import { KnowledgeBase, KnowledgeBaseQuestion } from "@/types/knowledgeBase";
import { apiRequest, ErrorType, PageRes } from "../api";

interface QuestionQueryParams {
    page?: number;
    limit?: number;
    s_and_question?: string;
}

export const knowledgeBaseService = {
    async getAll(query: any, page: number, limit: number): Promise<[PageRes<KnowledgeBase> | null, ErrorType | null]> {
        return apiRequest<PageRes<KnowledgeBase>>({
            loaderKey: "getAllKnowledgeBase",
            method: 'get',
            url: "/app/knowledge-base",
            params: { ...query, page, limit }
        });
    },

    async getOne(id: string): Promise<[KnowledgeBase | null, ErrorType | null]> {
        return apiRequest<KnowledgeBase>({
            loaderKey: "getOneKnowledgeBase",
            method: 'get',
            url: `/app/knowledge-base/${id}`
        });
    },

    async newKnowledgeBase(data: KnowledgeBase): Promise<[KnowledgeBase | null, ErrorType | null]> {
        return apiRequest<KnowledgeBase>({
            loaderKey: "newKnowledgeBase",
            method: 'post',
            url: "/app/knowledge-base",
            data
        });
    },

    async updateKnowledgeBase(id: string, data: Partial<KnowledgeBase>): Promise<[KnowledgeBase | null, ErrorType | null]> {
        return apiRequest<KnowledgeBase>({
            loaderKey: "updateKnowledgeBase",
            method: 'put',
            url: `/app/knowledge-base/${id}`,
            data
        });
    },

    async getQuestions(
        id: string,
        params: QuestionQueryParams = {}
    ): Promise<[PageRes<KnowledgeBaseQuestion> | null, ErrorType | null]> {
        return apiRequest<PageRes<KnowledgeBaseQuestion>>({
            loaderKey: "getQuestionsKnowledgeBase",
            method: 'get',
            url: `/app/knowledge-base/${id}/questions`,
            params
        });
    },

    async newQuestion(id: string, data: KnowledgeBaseQuestion): Promise<[KnowledgeBaseQuestion | null, ErrorType | null]> {
        return apiRequest<KnowledgeBaseQuestion>({
            loaderKey: "newQuestionKnowledgeBase",
            method: 'post',
            url: `/app/knowledge-base/${id}/questions`,
            data
        });
    },

    async updateQuestion(
        knowledgeBaseId: string,
        questionId: string,
        data: Partial<KnowledgeBaseQuestion>
    ): Promise<[KnowledgeBaseQuestion | null, ErrorType | null]> {
        return apiRequest<KnowledgeBaseQuestion>({
            loaderKey: "updateQuestionKnowledgeBase",
            method: 'put',
            url: `/app/knowledge-base/${knowledgeBaseId}/questions/${questionId}`,
            data
        });
    }
};
